/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { memo } from 'react'
import styled from 'styled-components'

const DotsStyled = styled.div`
  display: flex;
  justify-content: center;
  .dot {
    cursor: pointer;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: var(--color-disabled);
    margin: 16px 4px 0;
    &.active {
      background-color: var(--color-primary);
    }
    @media screen and (max-width: 576px) {
      margin: 16px 8px 0;
    }
  }
`

const DotsBase = ({
  length,
  step,
  onClick,
}: {
  length: number
  step: number
  onClick: (val: number) => void
}) => {
  return (
    <DotsStyled>
      {React.Children.toArray(
        Array.from({ length }).map((x, i) => (
          <i
            key={i}
            onClick={() => onClick(i)}
            className={`dot ${step === i ? 'active' : ''}`}
            role="button"
            tabIndex={0}
            aria-labelledby="dot-step"
          />
        ))
      )}
    </DotsStyled>
  )
}
const Dots = memo(DotsBase)

export default Dots
